import React,{Component} from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import Vas from  '../Vas';
import '../css/SideNavigation.css';
import {Icon,MessageBox} from 'component-lib';
import { RequestAjaxClass, PaymentsModel } from 'models-lib';
import { DateTimeHelper } from 'utils-lib';

var moment = require('moment');
        moment().format();

var switchFalgsMobile = false;

class SideNavigation extends Component
{
    constructor(props){
        super(props);
        this.Request = new RequestAjaxClass();
        this.PaymentsModel = new PaymentsModel([this]);
        this.LangConfig = Vas.Config.Languages;
      }

    componentDidMount()
    {
        this.Request.setAuth(true);
        this.Request.setApiKey(Vas.ApiKey);
        this.Request.setApiUrl(Vas.ApiUrl);

        this.PaymentsModel.SetRequest(this.Request);

        let me = this;
        let body = $("body");
        //body.css("background-color", "white");
        body.bind("click",function(){
            var burgerMenuClick = localStorage.getItem("BurgerMenu","BurgerMenu");

            if(burgerMenuClick !== "BurgerMenu") {
                if(switchFalgsMobile == false) {
                    if(document.getElementById("mySidenav") != null){
                        document.getElementById("mySidenav").style.width = "0";
                    }
                  } else{
                    switchFalgsMobile = false;
                  }
            }
            else
                {localStorage.setItem("BurgerMenu","");}

            me.setState({});
        });

        $(document).keyup(function(e){

            if(e.which === 27){
                if($("#mySidenav").length>0)
                    {document.getElementById("mySidenav").style.width = "0";}

            }
        });

        let burgerMenu = $("#Menu");
        //body.css("background-color", "white");        
        burgerMenu.bind("click",function(){

            if(document.getElementById("mySidenav").style.width === "" || document.getElementById("mySidenav").style.width === "0px")
                {
                    document.getElementById("mySidenav").style.width = "auto";
                    localStorage.setItem("BurgerMenu","BurgerMenu");
                }

            me.setState({});
        });

        this.LogoClick();
    }

    Update(observer){
        let me = this;
        this.setState({},()=>{
          if(observer === "Payment"){
            let count = this.PaymentsModel.Count;
            let id = localStorage.getItem('vas_customerId');
            if (count > 0){
                let valid = false;
                let today = moment();
                me.PaymentsModel.Payments.forEach(p => {
                    if(p.ValidFrom !== null){
                        if(today.isAfter(DateTimeHelper.StringToDate(p.ValidFrom,true, localStorage.getItem('vas_language'))) === true){
                            valid = true;
                        }
                    }else{
                        valid = true;
                    }
                })
                if(valid === true){
                  Vas.GetView("Order", { CustomerId: id, ContractId : '00000' }, true);
                }else {
                  Vas.GetView("NoPayment", { CustomerId: id, NewContract : "true" }, true);
                }
            } else {
              Vas.GetView("NoPayment", { CustomerId: id, NewContract : "true" }, true);
            }
          }
        });
    }

    showFlags(){
        $("#MenuItemsSideNav").removeClass().addClass("languageMenu-items");
    }

    hideFlags(){
        $("#MenuItemsSideNav").removeClass().addClass("languageMenu-items-notVisible");
    }

    //VAS-30785: Da onMouseOver bzw. onMouseLeave bei mobilen Geräten nicht greift,
    //wurde diese Methode hinzugefügt. Sie wird bei onClick auf Sprache/Langeage getriggert.
    //Das switchFalgsMobile dient als Schalter. Wählbare Sprachen müssen beim 1. Klick angezeigt
    //und beim 2. Klick wieder ausgeblendet werden. Zusätzl. darf das Menü bei Klick auf
    //Sprache/Language nicht geschlossen werden. Erst bai Auswahl der Sprache.
    toggleFlagsMobil(){

        if($("#MenuItemsSideNav").hasClass("languageMenu-items")){
          $("#MenuItemsSideNav").removeClass().addClass("languageMenu-items-notVisible");
        } else{
          $("#MenuItemsSideNav").removeClass().addClass("languageMenu-items");
        }
  
        switchFalgsMobile = true;
      }

    SetLanguage(lang){
        if(lang === "en"){
            if(this.LangConfig.MessageChangeToEnglish === true){
              ReactDOM.render(<MessageBox 
                AppURL={Vas.ApplicationUrl} 
                Title={Vas.Resources.Titles["Note"]} 
                Message={<div>
                    {Vas.Resources.Labels["NoteChangeLanguageGerman"]}
                    {<br/>}
                    {Vas.Resources.Labels["NoteChangeLanguageEnglish"]}
                  </div>}
                Click={()=>{
                  localStorage.setItem("vas_language", lang);
                  window.location = window.location.pathname;
                }} /> 
                , document.getElementById('messageContainer'));
            }else{
              localStorage.setItem("vas_language", lang);
              window.location = window.location.pathname;
            }
          }else{
            localStorage.setItem("vas_language", lang);
            window.location = window.location.pathname;
          }

        /*let language = localStorage.getItem('vas_language');
        let supportedLanguages = require('./i18n/languages.json');
        supportedLanguages.Languages.forEach(function(value){
            if(value.Iso !== language){
                localStorage.setItem("vas_language", value.Iso);
                window.location = window.location.pathname;
            }
        });*/
    }

    LogoClick(){

        var kontrastNumber = localStorage.getItem('Kontrast');
    
        if(kontrastNumber == "true"){
            $(".NavBarItemTextSideNav").attr('style', 'background-color: #1d5c87; color: white !important;');
            $('.SideNav table td').attr('style', 'background-color: #1d5c87; color: white !important;');

              $("#mySidenav > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(1) > td:nth-child(1)").mouseenter(function() {
                $(this).attr('style', 'background-color: #00375b;');
                $('#mySidenav > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(1) > td:nth-child(1) > div:nth-child(2)').attr('style', 'background-color: #00375b;');
              }).mouseleave(function() {
                  $(this).attr('style', 'background-color: #1d5c87;');
                  $('#mySidenav > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(1) > td:nth-child(1) > div:nth-child(2)').attr('style', 'background-color: #1d5c87;');
              });

              $("#mySidenav > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(2) > td:nth-child(1)").mouseenter(function() {
                $(this).attr('style', 'background-color: #00375b;');
                $('#mySidenav > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(2) > td:nth-child(1) > div:nth-child(2)').attr('style', 'background-color: #00375b;');
              }).mouseleave(function() {
                  $(this).attr('style', 'background-color: #1d5c87;');
                  $('#mySidenav > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(2) > td:nth-child(1) > div:nth-child(2)').attr('style', 'background-color: #1d5c87;');
              });

              $("#mySidenav > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(3) > td:nth-child(1)").mouseenter(function() {
                $(this).attr('style', 'background-color: #00375b;');
                $('#mySidenav > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(3) > td:nth-child(1) > div:nth-child(2)').attr('style', 'background-color: #00375b;');
              }).mouseleave(function() {
                  $(this).attr('style', 'background-color: #1d5c87;');
                  $('#mySidenav > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(3) > td:nth-child(1) > div:nth-child(2)').attr('style', 'background-color: #1d5c87;');
              });

              $("#mySidenav > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(5) > td:nth-child(1)").mouseenter(function() {
                $(this).attr('style', 'background-color: #00375b;');
                $('#mySidenav > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(5) > td:nth-child(1) > div:nth-child(2)').attr('style', 'background-color: #00375b;');
              }).mouseleave(function() {
                  $(this).attr('style', 'background-color: #1d5c87;');
                  $('#mySidenav > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(5) > td:nth-child(1) > div:nth-child(2)').attr('style', 'background-color: #1d5c87;');
              });

              $("#mySidenav > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(7) > td:nth-child(1)").mouseenter(function() {
                $(this).attr('style', 'background-color: #00375b;');
                $('#mySidenav > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(7) > td:nth-child(1) > div:nth-child(2)').attr('style', 'background-color: #00375b;');
              }).mouseleave(function() {
                  $(this).attr('style', 'background-color: #1d5c87;');
                  $('#mySidenav > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(7) > td:nth-child(1) > div:nth-child(2)').attr('style', 'background-color: #1d5c87;');
              });

        } else {
            $(".NavBarItemTextSideNav").attr('style', 'background-color: #3393d3; color: white !important;');
            $('.SideNav table td').attr('style', 'background-color: #3393d3; color: white !important;');

            $("#mySidenav > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(1) > td:nth-child(1)").mouseenter(function() {
                $(this).attr('style', 'background-color: #0078c8;');
                $('#mySidenav > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(1) > td:nth-child(1) > div:nth-child(2)').attr('style', 'background-color: #0078c8;');
              }).mouseleave(function() {
                  $(this).attr('style', 'background-color: #3393d3;');
                  $('#mySidenav > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(1) > td:nth-child(1) > div:nth-child(2)').attr('style', 'background-color: #3393d3;');
              });

              $("#mySidenav > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(2) > td:nth-child(1)").mouseenter(function() {
                $(this).attr('style', 'background-color: #0078c8;');
                $('#mySidenav > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(2) > td:nth-child(1) > div:nth-child(2)').attr('style', 'background-color: #0078c8;');
              }).mouseleave(function() {
                  $(this).attr('style', 'background-color: #3393d3;');
                  $('#mySidenav > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(2) > td:nth-child(1) > div:nth-child(2)').attr('style', 'background-color: #3393d3;');
              });

              $("#mySidenav > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(3) > td:nth-child(1)").mouseenter(function() {
                $(this).attr('style', 'background-color: #0078c8;');
                $('#mySidenav > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(3) > td:nth-child(1) > div:nth-child(2)').attr('style', 'background-color: #0078c8;');
              }).mouseleave(function() {
                  $(this).attr('style', 'background-color: #3393d3;');
                  $('#mySidenav > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(3) > td:nth-child(1) > div:nth-child(2)').attr('style', 'background-color: #3393d3;');
              });

              $("#mySidenav > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(5) > td:nth-child(1)").mouseenter(function() {
                $(this).attr('style', 'background-color: #0078c8;');
                $('#mySidenav > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(5) > td:nth-child(1) > div:nth-child(2)').attr('style', 'background-color: #0078c8;');
              }).mouseleave(function() {
                  $(this).attr('style', 'background-color: #3393d3;');
                  $('#mySidenav > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(5) > td:nth-child(1) > div:nth-child(2)').attr('style', 'background-color: #3393d3;');
              });

              $("#mySidenav > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(6) > td:nth-child(1)").mouseenter(function() {
                $(this).attr('style', 'background-color: #0078c8;');
              }).mouseleave(function() {
                  $(this).attr('style', 'background-color: #3393d3;');
              });

              $("#mySidenav > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(7) > td:nth-child(1)").mouseenter(function() {
                $(this).attr('style', 'background-color: #0078c8;');
                $('#mySidenav > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(7) > td:nth-child(1) > div:nth-child(2)').attr('style', 'background-color: #0078c8;');
              }).mouseleave(function() {
                  $(this).attr('style', 'background-color: #3393d3;');
                  $('#mySidenav > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(7) > td:nth-child(1) > div:nth-child(2)').attr('style', 'background-color: #3393d3;');
              });
        }
      }

    render(){


        this.LogoClick();

        let customers = <tr></tr>;
        if(localStorage.getItem('vas_role') === "3"){
          customers =
          <tr>
                <td onClick={()=>{ Vas.GetView("Customers", null, true); }}>
                    <div className={"NavBarItemIconSideNav"}>
                        <Icon  Name={"Person"} Size={24} Color={"white"} Align={"left"}/>
                    </div>
                    <div className={"NavBarItemTextSideNav ItemDataSideNav"}>
                        {Vas.Resources.Labels["Employee"]}
                    </div>
                </td>
            </tr>
        }

        let newContract = <tr></tr>;
        if(localStorage.getItem('vas_role') === "1"){
          newContract = <tr>

          <td onClick={()=>{ 
              localStorage.setItem("vas_selectedTab","NewContractDataLink"); 
              let id = localStorage.getItem('vas_customerId');
                if(localStorage.getItem('vas_role') === "3"){
                    Vas.GetView("Order", { CustomerId: id, ContractId : '00000' }, true);
                }else{
                    this.PaymentsModel.GetPaymentsByCustomerId(id,null, null, null, null, null, 4);
                }
              
           }}>
              <div className={"NavBarItemIconSideNav"}>
                  <Icon  Name={"Contracts"} Size={24} Color={"white"} Align={"left"}/>
              </div>
              <div className={"NavBarItemTextSideNav ItemContractsSideNav"}>
                  {Vas.Resources.Labels["PriceInformation"]}
              </div>
          </td>
      </tr>
        }

        let country = '';
        let countryTab = <tr></tr>;
        if(this.LangConfig.OnlyGerman === false){
          if (localStorage.getItem("vas_language") === "de"){
            country = (<Icon Name={"FlagGermany"} Align={"left"} PaddingTop={"2px"}/>);
          } else {
              country = (<Icon Name={"FlagUnitedKingdom"} Align={"left"} PaddingTop={"2px"}/>);
          }

          countryTab = <tr>
            <td id="LanguageDataLinkSideNav" 
                onMouseOver={()=>{this.showFlags();}} 
                onMouseLeave={()=>{this.hideFlags();}}
                onClick={()=>{this.toggleFlagsMobil();}}>
            {country}
                <div style={{display:'inline', paddingLeft:'6px'}}>{Vas.Resources.Labels["Language"]}</div>
                {/* <div id="MenuItemsSideNav" className={'languageMenu-items-notVisible'}style={{position:'relative', top:'0px'}}>
                    <div id="First_Lang" onClick={()=>{this.SetLanguage("de");}}>Deutsch</div>
                    <div id="Last_Lang" onClick={()=>{this.SetLanguage("en");}}>English</div>
                </div> */}
                <div id="First_Lang" onClick={()=>{this.SetLanguage("de");}}>Deutsch</div>
                <div id="Last_Lang" onClick={()=>{this.SetLanguage("en");}}>English</div>
            </td>
        </tr>
        }

        return(<div id="mySidenav" className="SideNav">
            <table>
                <tbody>
                    <tr>
                        <td onClick={()=>{ Vas.GetView("CustomerCard", {Id: localStorage.getItem('employee_id') ? localStorage.getItem('employee_id') : localStorage.getItem('vas_customerId')}, true); }}>
                            <div className={"NavBarItemIconSideNav"}>
                                <Icon  Name={"Account"} Size={24} Color={"white"} Align={"left"}/>
                            </div>
                            <div className={"NavBarItemTextSideNav ItemDataSideNav"}>
                                {Vas.Resources.Labels["Account"]}
                            </div>
                        </td>
                    </tr>
                    {newContract}
                    <tr>

                        <td onClick={()=>{ Vas.GetView("Contracts", {All:true}, true); }}>
                            <div className={"NavBarItemIconSideNav"}>
                                <Icon  Name={"Contracts"} Size={24} Color={"white"} Align={"left"}/>
                            </div>
                            <div className={"NavBarItemTextSideNav ItemContractsSideNav"}>
                                {Vas.Resources.Labels["Contracts"]}
                            </div>
                        </td>
                    </tr>
                    {customers}
                    <tr>
                        <td style={{ textAlign: 'right', paddingRight: '6px'}} onClick={()=>{ Vas.GetView("Account", null, true); }}>
                            <div className={"NavBarItemIconSideNav"}>
                                <Icon Name={"Person"} Size={24} Color={"white"} Align={"left"}/>
                            </div>
                            <div className={"NavBarItemTextSideNav ItemAccountSideNav"}>                                        
                                { localStorage.getItem("vas_username")}
                                        
                            </div>
                        </td>
                    </tr>
                    {countryTab}
                    <tr>
                        <td onClick={()=>{ Vas.Signout();}}>
                            <div className={"NavBarItemIconSideNav"}>
                                <Icon  Name={"SignOut"} Size={24} Color={"white"} Align={"left"}/>
                            </div>
                            <div className={"NavBarItemTextSideNav"}>
                                        {Vas.Resources.Labels["SignOut"]}
                             </div>
                        </td>
                     </tr>
                                               
                </tbody>
            </table>
        </div>);
    }
}
export default SideNavigation;
